module.exports = __webpack_public_path__ + "static/media/money-mouth-face.c36cf7d6.png";